// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3W6AX","right":"styles_right__O4mJs"};